<template>
  <badgeComponent :text="text" :badgeClass="badgeClass" class="badge-list" v-if="params.text" />
</template>

<script type="text/javascript">
import Vue from "vue";
import badgeComponent from "../../badge/badgeComponent.vue";
export default Vue.extend({
  components: {
    badgeComponent: badgeComponent
  },
  computed: {
    text: {
      // getter
      get: function() {
        if (this.params.text) {
          return this.params.text;
        } else return "None";
      },
      // setter
      set: function(newValue) {
        this.params.value = newValue;
      }
    },
    badgeClass: {
      // getter
      get: function() {
        if (!this.params.value) {
          return "badge-danger";
        } else {
          switch (this.params.value) {
            case "20":
              return "badge-light";
            case "30":
              return "badge-warning";
            case "40":
            default:
              return "badge-success";
            case "60":
              return "badge-info";
            case "80":
              return "badge-secondary";
          }
        }
      },
      // setter
      set: function(newValue) {
        this.params.value = newValue;
      }
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
});
</script>
